/**
 * Media query strings.
 */
export enum MQ {
  SM = <any>'(min-width: 576px)',
  MD = <any>'(min-width: 768px)',
  LG = <any>'(min-width: 992px)',
  XL = <any>'(min-width:  1200px)',
}



// WEBPACK FOOTER //
// ./src/common/components/Theme.ts